import React, { useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from "../../redux/actions/authActions";
import OrderFlowProductWorldList from './OrderFlowProductWorldList';
import './OrderFlowProducts.css'; 

const OrderFlowProductWorld = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const sellerRoute = location.pathname.replace("/orderflow-products", "").replace(/^\/+/, ""); 
    // const sellerRoute = location.pathname.replace("/orderflow-products/", "");
    const authState = useSelector((state) => state.authReducer || {});
    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "User";
    const { moduleName } = useParams();

    const dispatch = useDispatch();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/orderflow-home");
    };
    
    return (
        <div>
            <header className="sticky top-0 z-50 bg-black border border-cyan-400 px-4 py-2 flex flex-row items-center justify-between shadow-lg mb-4">
                <div className='flex flex-col items-start justify-start'>
                    <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-2'>
                        <i className="fas fa-shopping-cart text-xl lg:text-2xl text-yellow-200"></i>Khareedo - {sellerRoute.toUpperCase()}
                    </h2>
                    <h2 className='text-sm font-bold text-white text-center mb-2'>
                        Buy & Earn from Referral to Elevate Personal & Family Income. 
                    </h2> 
                </div>  
                <div>
                    <div className="hidden md:flex items-center gap-3">
                        {isLoggedIn ? (
                            <>
                                <div className="text-xs text-left text-blue-300">{userName}</div>
                                <button
                                    onClick={handleLogout}
                                    className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                                    title="Logout"
                                >
                                    ⏻
                                </button>
                            </>
                        ) : (
                            <>
                                <Link
                                    to="/login"
                                    className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                                >
                                    Login
                                </Link>
                            </>
                        )}
                    </div>
                
                    {/* Mobile hamburger */}
                    <button
                        onClick={() => setIsMobileMenuOpen((s) => !s)}
                        className="md:hidden w-6 h-6 flex items-center justify-center text-lg text-blue-300 bg-blue-500"
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? "×" : "☰"}
                    </button>
                </div>
            </header>
          
            {/* Mobile menu content */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-black border-b border-cyan-400 px-4 py-2 animate-fadeIn">
                    {isLoggedIn ? (
                        <div className="flex flex-row items-center justify-center gap-3">
                            <span className="text-blue-300 font-medium whitespace-nowrap h-7 text-xs">
                                {userName}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                                title="Logout"
                            >
                                ⏻
                            </button>
                        </div>
                    ) : (
                        <div className="flex flex-row items-center justify-center gap-6">
                            <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                                Login
                            </Link>
                        </div>
                    )}
                </div>
            )}  

            <div>
                <OrderFlowProductWorldList param1={moduleName} param2={"INR"} sellerRoute={sellerRoute}/>
            </div>

            {/* Footer */}
            <footer className="bg-black border-t border-blue-800 text-blue-300 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                        © 2025 Think5Whys Global DeepTech Solutions
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                        <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
                        <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
                        <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default OrderFlowProductWorld;